<template>
    <p
        :class="
            twMerge(
                'whitespace-pre-line text-left text-[0.875rem] font-normal leading-[1.6] lg:text-[1rem]',
                locale === 'ja' && '',
                locale === 'ko' && '',
                (locale === 'en' || lang === 'en') &&
                    'font-en leading-[1.3] tracking-[-0.01em]',
                $attrs.class,
            )
        "
    >
        <slot />
    </p>
</template>

<script setup>
import { twMerge } from "tailwind-merge";
const { lang = "tw" } = defineProps({ lang: { type: String, default: "tw" } });

const { locale } = useI18n();
</script>
